import { useState } from "react";
import { inject, observer } from "mobx-react";

import InputNumberUI from "@UI/InputNumberUI";
import SelectSuggestUI from "@UI/SelectSuggestUI";

import { Calendar } from "primereact/calendar";
import moment from "moment";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const AddAgreement = inject("mainStore")(
    observer(({ mainStore, item, contract, select, getContract }) => {
        const detailData = mainStore.getMainStore("detailData");
        const [data, setData] = useState(item);
        const isDisable = item._id;

        const handleGetContract = async () => {
            let obj = { ...data, contractDate: moment(data.contractDate).format("YYYY-MM-DD"), expirationDate: "", vendorId: detailData._id, contractType: "CONTRACT_TYPE_ADDITIONAL_AGREEMENT" };
            const resp = await mainStore.postByUrl("promo/contracts", obj, false, false, false);
            if (resp && resp.success) {
                const response = await mainStore.getByUrl(`promo/createContractInOzon/${resp.data._id}`, false, false, false);
                if (response && response.success) {
                    getContract();
                    mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "Договор отправлено в ORD. Вы можете опубликовать вендор " });
                }
            }
        };

        const selectedCountryTemplate = (option, props) => {
            if (option) {
                return (
                    <div className="contract__item">
                        <div className="number">
                            {"ID Договора "}
                            <span>{option.ozonId}</span>
                        </div>
                        <span className="name">от {moment(option.contractDate).format("DD.MM.YYYY")}</span>
                    </div>
                );
            } else {
                return <span>0000000000000</span>;
            }
        };

        const countryOptionTemplate = (option) => {
            return (
                <div className="contract__item">
                    <div className="number">
                        {"ID Договора "}
                        <span>{option.ozonId}</span>
                    </div>
                    <span className="name">от {moment(option.contractDate).format("DD.MM.YYYY")}</span>
                </div>
            );
        };

        const disableBlock = detailData.vendorInfo?.ozonId ? true : false;

        const disableButton = !data.contractDate || !data.contractNumber || !data.parentId;

        return (
            <div className={`step__block ${disableBlock ? "" : "disable"}`}>
                <div className="block">
                    <div className="row">
                        <SelectSuggestUI
                            isDisabled={!disableBlock || isDisable}
                            options={contract}
                            value={data.parentId}
                            optionLabel="contractNumber"
                            optionValue="_id"
                            filter={false}
                            placeholder=""
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, parentId: e.value };
                                })
                            }
                            label="Выберите договор"
                            required
                            valueTemplate={selectedCountryTemplate}
                            itemTemplate={countryOptionTemplate}
                        />
                    </div>

                    <div className="row">
                        <div className="wrapper">
                            <InputNumberUI
                                value={Number(data.contractNumber)}
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, contractNumber: `${e.value}` };
                                    })
                                }
                                placeholder="0000000000000"
                                label="Номер соглашения"
                                required
                                disabled={!disableBlock || isDisable}
                                useGrouping={false}
                            />
                        </div>
                        <div className="wrapper">
                            <label>Дата доп.соглашения*</label>
                            <Calendar
                                value={data.contractDate ? moment(data.contractDate).toDate() : ""}
                                disabled={!disableBlock || isDisable}
                                dateFormat="dd.mm.yy"
                                locale="rus"
                                onChange={(e) =>
                                    setData((prev) => {
                                        return { ...prev, contractDate: e.value };
                                    })
                                }
                            />
                            <i className="pi pi-calendar"></i>
                        </div>
                    </div>

                    <div className="row">
                        <SelectSuggestUI
                            isDisabled={!disableBlock || isDisable}
                            options={select}
                            value={data.subjectType}
                            optionLabel="label"
                            optionValue="type"
                            filter={false}
                            placeholder=""
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, subjectType: e.value };
                                })
                            }
                            label="Сведение о предмете договора"
                            required
                        />

                        <InputNumberUI
                            value={Number(data.price)}
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, price: `${e.value}` };
                                })
                            }
                            placeholder="Укажите сумму"
                            label="Cумма договора с учетом налога"
                            disabled={!disableBlock || isDisable}
                            useGrouping={false}
                        />
                    </div>
                </div>

                {data._id && data.contractNumber ? (
                    <div className="ord__id">
                        <div className="number">
                            {"ID Договора "}
                            <span>{data.ozonId}</span>
                        </div>
                        <span className="name">от {moment(data.contractDate).format("DD.MM.YYYY")}</span>
                    </div>
                ) : null}

                {!data._id ? (
                    <ButtonUI className="button__rate" label={"Отправить доп.соглашение в кабинет ORD"} icon="pi pi-file" severity="success" outlined onClick={() => handleGetContract()} style={{ width: "100%" }} disabled={disableButton} />
                ) : null}
            </div>
        );
    }),
);

export default AddAgreement;
